/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { createPortal } from 'react-dom';
import { cn } from '@Utils';

import { icon_close } from '@Assets';

interface ModalProps {
  children: React.ReactNode;
  modalOpen: boolean;
  closeModal: () => void;
  className?: string;
  title?: string;
  closeClickOutside?: boolean;
  hideClose?: boolean;
}

const Modal = ({
  children,
  modalOpen,
  closeModal,
  className,
  title,
  closeClickOutside = true,
  hideClose = false,
}: ModalProps) => {
  if (!modalOpen) return null;

  return createPortal(
    <dialog
      className="fixed left-0 top-0 z-[999999] flex h-screen w-full cursor-pointer items-center justify-center bg-[#00000095] px-4 sm:px-12"
      onClick={(e) => {
        if (!closeClickOutside) return;

        e.preventDefault();
        closeModal();
      }}>
      <div
        className={cn(
          'relative flex w-full max-w-lg flex-col items-center justify-center gap-6 rounded-md bg-white p-6',
          className,
        )}
        onClick={(e) => e.stopPropagation()} // Prevents the modal from closing when clicking on the content
      >
        {title && <h4 className="w-full text-xl font-semibold text-gray-900">{title}</h4>}
        {!hideClose && (
          <div className="absolute top-5 right-5" onClick={closeModal}>
            <img src={icon_close} alt="close_user" className="w-3 text-gray-200 ml-auto" />
          </div>
        )}
        {children}
      </div>
    </dialog>,
    document.body,
  );
};

export default Modal;
